<template>
    <div class="tiktokWithdrawal">
        <div class="tiktokWithdrawal-info">
            <div class="tiktokWithdrawal-info-left">
                <h5 class="tiktokWithdrawal-title">提现说明</h5>
                <!-- <p>新版提现页面：指选择【不包税】方案之后抖音端的收益，抽佣比例为7%-8%，不完税；</p>
                <p>旧版提现页面：指选择【不包税】方案之前抖音端的收益余额+快手端的全部收益，抽佣比例为10%，完税。</p> -->
                <p>新版提现页面：指在抖音商户提现；</p>
                <p>旧版提现页面：指在豆包账户提现。</p>
            </div>
            <div>
                <el-button type="primary" @click="gooldWithdrawal" size="medium">进入旧版提现</el-button>
            </div>
        </div>
        <div style="padding-top: 12px;" class="tiktokWithdrawal-iframe">
            <iframe :src="url" width="100%" height="100%" frameborder="0" scrolling="auto" border="0" allowtransparency="yes" marginheight="0" marginwidth="0"></iframe>
        </div>
    </div>
</template>
<script>
import { mapActions} from 'vuex'
export default {
    props: {
        id: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            url: ''
        }
    },
    created() {
        this.getMerchantAddhtml()
         this.$nextTick(() => {
            document.body.classList.add('tiktokWithdrawal_index')
        })
    },
    beforeDestroy() {
        document.body.classList.remove('tiktokWithdrawal_index')
    },
    methods: {
        ...mapActions('dataCenter', ['addSubMerchant']),
        async getMerchantAddhtml() {
            let res = await this.addSubMerchant({url_type: 2, id: this.id})
            this.url = res.url
        },
        gooldWithdrawal() {
            this.$emit('change', 2)
        }
    }
}
</script>
<style lang="less">
    .tiktokWithdrawal_index {
        .content {
            max-width: 1435px!important;
            min-width: 1435px!important;
            .content_right_con {
                >div{
                    height: 100%;
                }
            }
        }
    }
</style>
<style lang="less" scoped>
.tiktokWithdrawal {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    .tiktokWithdrawal-info {
        display: flex;
        justify-content: space-between;
        padding:15px;
        border: 1px solid rgb(232, 232, 232);
        border-radius: 4px;
        flex: 0 0 auto;
        p{
            font-size: 13px;
            color: rgb(96, 106, 120);
            line-height: 20px;
        }
    }
    .tiktokWithdrawal-iframe {
        flex: 1 0 auto;
        height: 0;
    }
    .tiktokWithdrawal-title {
        font-size: 16px;
        line-height: 22px;
        padding-bottom: 12px;
        color: rgb(29, 37, 47);
        font-weight: normal;
    }
}
</style>
